package info.rezident.app.ui.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.css.resize
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.InputStyle
import com.varabyte.kobweb.silk.components.forms.InputVars
import com.varabyte.kobweb.silk.components.forms.OutlinedInputVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.GeneralKind
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import info.rezident.app.ui.theme.AppTheme
import org.jetbrains.compose.web.attributes.builders.TextAreaAttrsScope
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.TextArea

val placeholderColorStyle = CssStyle {
    if (colorMode.isDark) {
        cssRule("::placeholder") {
            Modifier.color(Color("#808080"))
        }
    } else {
        cssRule("::placeholder") {
            Modifier.color(Color("#505050"))
        }
    }
}

@Composable
fun LargeTextArea(
    value: String,
    placeholder: String,
    unfocusedBorderColor: CSSColorValue = InputVars.BorderColor.value(),
    textColor: CSSColorValue? = null,
    placeholderStyle: CssStyle<GeneralKind> = placeholderColorStyle,
    paddingLeftRight: CSSpxValue = 8.px,
    paddingTopBottom: CSSpxValue = 8.px,
    minLength: Int = 5,
    errorMessage: String = "Introduceți minim $minLength caractere",
    onValueChange: (String) -> Unit
) {
    var isFocused by remember { mutableStateOf(false) }
    var isTouched by remember { mutableStateOf(false) }
    var isTextValid by remember { mutableStateOf(true) }

    // Determine if we should show the error message
    val showError = isTouched && !isFocused && !isTextValid

    // Validate the text based on length requirements
    LaunchedEffect(value) {
        isTextValid = value.isEmpty() || (value.isNotBlank() && value.length >= minLength)
    }

    Column(
        modifier = Modifier.fillMaxWidth()
    ) {
        val textAreaAttrs = InputStyle.toModifier(OutlinedInputVariant).toAttrs<TextAreaAttrsScope>()
        val textStyleAttrs = AppTheme.typography.body1.toAttrs<TextAreaAttrsScope>()
        val placeholderAttrs = placeholderStyle.toAttrs<TextAreaAttrsScope>()
        val focusAttrs = Modifier
            .onFocusIn {
                isFocused = true
                isTouched = true
            }
            .onFocusOut {
                isFocused = false
            }
            .toAttrs<TextAreaAttrsScope>()
        val errorColor = AppTheme.colors.error

        TextArea(value) {
            textAreaAttrs(this)
            textStyleAttrs(this)
            placeholderAttrs(this)
            focusAttrs(this)

            onInput {
                onValueChange(it.value)
            }
            placeholder(placeholder)

            style {
                backgroundColor(Color.transparent)
                textColor?.let { color(it) }
                width(100.percent)
                minHeight(100.px)
                paddingLeft(paddingLeftRight)
                paddingTop(paddingTopBottom)
                paddingRight(paddingLeftRight)
                paddingBottom(paddingTopBottom)
                resize(Resize.Vertical)

                borderRadius(6.px)
                if (showError) {
                    border(2.px, style = LineStyle.Solid, color = errorColor)
                } else {
                    border(1.px, style = LineStyle.Solid, color = unfocusedBorderColor)
                }
            }
        }

        // Display error message if needed
        if (showError) {
            SpanText(
                text = errorMessage,
                modifier = Modifier
                    .margin(top = 4.px, left = 8.px)
                    .fontSize(14.px)
                    .color(AppTheme.colors.error)
            )
        }
    }
}